/* eslint-disable import/prefer-default-export */
export const UPC_VALIDATOR_REPOSITORY = Symbol.for('UPC_VALIDATOR_REPOSITORY');
